<template>
  <h5 class="case-title mb-4">Case {{ examination.case_no }}</h5>
  <div class="draft-exam-header shadow-box mb-4">
    <div class="kv-grid">
      <div class="kv-key">ID</div>
      <div class="kv-val font-monospace">{{ examination.id }}</div>
      <div class="kv-key">Manifest ID</div>
      <div class="kv-val font-monospace">{{ examination.form_id }}</div>

      <div class="kv-key">Progress</div>
      <div class="kv-val">
        <div class="progress w-100" style="height: 10px; border-radius: 6px">
          <div
            class="progress-bar"
            role="progressbar"
            :style="{ width: (examination.progress?.percent || 0) + '%' }"
            :aria-valuenow="examination.progress?.percent || 0"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <span class="progress-label"
              >{{ examination.progress?.percent || 0 }}%</span
            >
          </div>
        </div>
      </div>
      <div class="kv-key">Status</div>
      <div class="kv-val">
        <span :class="topBadgeClass(examination.status)">{{
          examination.status
        }}</span>
      </div>

      <div class="kv-key">User</div>
      <div class="kv-val">{{ examination.user_name }}</div>
      <div class="kv-key">Centre</div>
      <div class="kv-val">{{ examination.center_name }}</div>

      <div class="kv-key">Product</div>
      <div class="kv-val">{{ examination.product }}</div>
      <div class="kv-key">Initiated</div>
      <div class="kv-val">{{ examination.initiated_at }}</div>

      <div class="kv-key">Device</div>
      <div class="kv-val font-monospace">
        {{ examination.os_platform || "—" }} <span class="text-muted">v</span
        >{{ examination.os_version || "—" }}
      </div>
      <div class="kv-key">App</div>
      <div class="kv-val font-monospace">
        {{ examination.app_version || "—" }}
      </div>

      <div class="kv-key">Latest upload</div>
      <div class="kv-val">{{ examination.latest_upload || "—" }}</div>
      <div class="kv-key">Latest completion</div>
      <div class="kv-val">{{ examination.latest_completion || "—" }}</div>
    </div>
  </div>
</template>

<script>
import { topBadgeClass } from "./utils/helpers";

export default {
  name: "ExaminationHeader",
  props: {
    examination: { type: Object, required: true },
  },
  methods: { topBadgeClass },
};
</script>

<style scoped>
.case-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #212529;
}
.kv-grid {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr) 120px minmax(0, 1fr);
  column-gap: 12px;
  row-gap: 10px;
  align-items: center;
}
.kv-key {
  color: #6c757d;
  font-weight: 500;
}
.kv-val {
  min-height: 1.25rem;
}
.progress-bar {
  position: relative;
}
.progress-label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  color: #fff;
}
</style>
